exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.-card[data-v-21fa22c2] {\n  width: 100%;\n  border-radius: 8px;\n}\n.-header[data-v-21fa22c2] {\n  width: 100%;\n}\n.-header p[data-v-21fa22c2] {\n    display: block;\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21fa22c2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modals/BasicModal.vue
// module id = +HDo
// module chunks = 0